import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import { useAppServices } from 'hook/services'
import { useEffect, useState } from 'react'
import EditModal from '../../EditModal'
import { Chip, Typography, Paper, Box, Divider } from '@mui/material'

export default function DataTableData() {
  const AppService = useAppServices()
  const [categories, setCategories] = useState([])
  const [medialibrary, setMedialibrary] = useState([])
  const [loader, setLoader] = useState(true)

  const getCategories = async () => {
    const { response } = await AppService.medialibrarycategory.get({
      toaster: false,
    })
    if (response) {
      setCategories(response.data)
    } else {
      setCategories([])
    }
  }

  const getMedialibrary = async () => {
    const { response } = await AppService.medialibrary.get({
      toaster: false,
    })
    if (response) {
      setMedialibrary(response.data)
    } else {
      setMedialibrary([])
    }
  }

  const onLoad = async () => {
    setLoader(true)
    await Promise.all([getCategories(), getMedialibrary()])
    setLoader(false)
  }

  const handleDelete = async (id) => {
    const { response } = await AppService.medialibrarycategory.delete({
      query: `_id = ${id}`,
    })
    if (response) onLoad()
  }

  useEffect(() => {
    onLoad()
  }, [])

  const medialibraryByCategory = categories?.map(category => {
    const categoryMedialibrary = medialibrary.filter(
      medialibrary => medialibrary?.category?._id === category?._id
    )

    return {
      ...category,
      medialibrary: categoryMedialibrary
    }
  })

  return {
    loader: loader,
    handleRefresh: onLoad,
    dataTableData: {
      columns: [
        { Header: 'Category', accessor: 'category' },
        { Header: 'Medialibrary', accessor: 'medialibrary' },
        { Header: 'Action', accessor: 'action' },
      ],
      rows: medialibraryByCategory.map((category) => ({
        category: category.name,
        medialibrary: (
          <Box sx={{ width: '100%', minWidth: '300px' }}>
            <Paper
              elevation={1}
              sx={{
                width: '130%',
                p: 2,
                borderRadius: '8px',
                backgroundColor: 'background.paper',
                border: '1px solid',
                borderColor: 'divider',
              }}
            >
              {category?.medialibrary?.length > 0 ? (
                <Box sx={{ width: '100%' }}>
                  {category?.medialibrary?.map((medialibrary, index) => (
                    <Box key={medialibrary?._id}>
                      <Chip
                        label={
                          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <Typography variant="outlined" sx={{ fontWeight: 'bold', fontSize: 14 }}>
                              {medialibrary?.name}
                            </Typography>
                            <Typography variant="outlined" >
                              type: {medialibrary?.type}
                            </Typography>
                          </Box>
                        }
                        variant="outlined"
                        sx={{
                          width: '100%',
                          height: 'auto',
                          borderRadius: 1,
                          justifyContent: 'flex-start',
                          alignItems: 'flex-start',
                          paddingY: 1,
                          paddingX: 1.5,
                          '& .MuiChip-label': {
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            padding: 0,
                          },
                        }}
                      />


                      {index < category?.medialibrary?.length - 1 && (
                        <Divider sx={{
                          my: 1,
                          borderColor: '#000000',
                          borderBottomWidth: 10,
                          opacity: 1
                        }} />
                      )}
                    </Box>
                  ))}
                </Box>
              ) : (
                <Typography variant="outlined" sx={{ color: 'red' }}>
                  No Medialibrary items available
                </Typography>
              )}
            </Paper>
          </Box>
        ),
        action: (
          <MDBox sx={{ display: 'flex', justifyContent: 'flex-start' }}>
            <EditModal data={category} handleRefresh={onLoad} />
            <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => handleDelete(category?._id)}
            >
              Delete
            </MDButton>
          </MDBox>
        ),
      })),
    },
  }
}